export function copyTo(s, t) {
    for (let i = 0; i < s.length; i++)
        t[i] = s[i];
}
//# sourceMappingURL=copy.js.map